import React from 'react';
import UnderConstruction from '../comunes/UnderConstruction';
import Base from '../comunes/Base';
function Inicio() {
    return(
            <React.StrictMode>
                 <Base/> 
                 <UnderConstruction/>
            </React.StrictMode>
);
}
export default Inicio;